import PropTypes from 'prop-types';
import React from 'react';
import { M } from '@dashboard-experience/mastodon';
import { i18n } from '@international/mastodon-i18n';

const DropDown = ({
  input: { onChange, value, name },
  options,
  meta,
  titleText = '',
  label = '',
  showDobError,
  disabled = false,
}) => {
  const { error, touched } = meta;
  const showErrorMessage = touched && error;

  // based on the options passed from 'lib/options'
  const fields = options.map(option => ({
    name: option.i18n ? i18n.getStr(option.name) : option.name,
    value: option.value,
    disabled: option.disabled || false,
    requiredForVerification: option.requiredForVerification,
  }));
  // map redux-form value (primitive or object) to the dropdown option
  const selectedItem =
    fields.slice(1).find(item => item?.value === value?.selectedItem?.value) ||
    value;

  return (
    <M.Dropdown
      id={name}
      name={name}
      label={label || fields[0]}
      items={fields.splice(1)}
      itemToString={item => item.name}
      invalid={showErrorMessage || showDobError}
      invalidText={showErrorMessage ? i18n.getStr(error) : null}
      value={value}
      selectedItem={selectedItem}
      onChange={onChange}
      titleText={titleText}
      disabled={disabled}
    />
  );
};

DropDown.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  titleText: PropTypes.string,
  label: PropTypes.string,
  showDobError: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default DropDown;
